import React from "react"
import "./Footer.scss"
import PropTypes from "prop-types"

const Footer = props => {
  return props.loading ? null : <footer className="Footer" />
}

Footer.propTypes = {
  loading: PropTypes.bool,
}

export default Footer
